import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit';
import { style } from './zui-multipicker-css.js';
import '@zywave/zui-pager';
import '@zywave/zui-search';

/**
 * `<zui-multipicker>` is the wrapper around `<zui-multipicker-item>`'s, it renders slots for many of multipicker features such as search, pagination, count and other controls.
 * @element zui-multipicker
 *
 * @slot search - Slot in a search, such as `<zui-search>`
 * @slot results-count - Slot for total available results count
 * @slot bulk-add - Slot for a `button`, or `<zui-button>`, to bulk add all pickers
 * @slot picker-items - Slot for where all available `<zui-multipicker-item>`'s go, make a container such as `<div` `slot="picker-items">` then place `<zui-multipicker-item>`'s within
 * @slot selected-count - Slot for total picker results chosen
 * @slot bulk-remove - Slot for a `button`, or `<zui-button>`, to bulk remove all pickers
 * @slot selected-picker-items - Slot for where all chosen `<zui-multipicker-item>`'s go, make a container such as `<div` `slot="picker-items">` then place `<zui-multipicker-item>`'s within
 * @slot pager - Slot for pagination
 *
 * @cssprop [--zui-multipicker-item-font-size=inherit] - If necessary, this property exists for font size control, by default it should `inherit` successfully
 */
export class ZuiMultipicker extends ZuiBaseElement {
  firstUpdated() {
    this.addEventListener('change', (e) => {
      e.stopPropagation();
    });
  }

  static get styles() {
    return [super.styles, style];
  }

  render() {
    return html`
      <div class="search">
        <slot
          @change="${(e: Event) => {
            e.stopPropagation();
          }}"
          name="search"
        ></slot>
      </div>
      <div class="multipicker">
        <section class="left">
          <div class="info-row">
            <div class="results"><slot name="results-count"></slot></div>
            <div class="bulk-add"><slot name="bulk-add"></slot></div>
          </div>
          <div class="item-container"> <slot name="picker-items"></slot> </div>
        </section>
        <section class="right">
          <div class="info-row">
            <div class="results"><slot name="selected-count"></slot></div>
            <div class="bulk-remove"><slot name="bulk-remove"></slot></div>
          </div>
          <div class="item-container-selected">
            <slot class="selected-picker-items" name="selected-picker-items"></slot>
          </div>
        </section>
      </div>
      <div class="pager">
        <div class="pager-slot"><slot name="pager"></slot></div>
        <div class="pager-whitespace"></div>
      </div>
    `;
  }
}

window.customElements.define('zui-multipicker', ZuiMultipicker);

declare global {
  interface HTMLElementTagNameMap {
    'zui-multipicker': ZuiMultipicker;
  }
}
